<template>
  <v-container class="register-container">
    <!-- locale -->
    <v-layout row>
      <v-flex class="register-locale">
        <div>居住地：</div>
      </v-flex>
      <v-flex>
        <v-radio-group
          v-model="selectedLocale"
          name="locale"
          class="register-locale"
          required
          row
        >
          <v-radio value="ja" label="日本"></v-radio>
          <v-radio value="en" label="海外"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>

    <!-- info -->
    <template v-if="!selectedLocale">
      <v-layout>
        <v-flex>
          <div class="register-attention">
            居住地を選択後、下記項目を入力してください
          </div>
        </v-flex>
      </v-layout>
    </template>

    <!-- 居住地:日本 -->
    <template v-if="selectedLocale === 'ja'">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-text-field
            v-model="inputLastName"
            name="last_name"
            type="text"
            label="姓"
            required
            :error-messages="errors.last_name"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            v-model="inputFirstName"
            name="first_name"
            type="text"
            label="名"
            required
            :error-messages="errors.first_name"
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-text-field
            v-model="inputLastNameKana"
            name="last_name_kana"
            type="text"
            label="セイ"
            required
            :error-messages="errors.last_name_kana"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            v-model="inputFirstNameKana"
            name="first_name_kana"
            type="text"
            label="メイ"
            required
            :error-messages="errors.first_name_kana"
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout v-if="!inviteTemplateFlg">
        <v-flex xs12>
          <v-text-field
            v-model="inputEmail"
            name="email"
            type="email"
            label="メールアドレス"
            required
            :error-messages="errors.email"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout v-if="inviteTemplateFlg">
        <v-flex xs12>
          <v-text-field
            v-model="inputInviteEmail"
            name="email"
            type="email"
            label="登録予定メールアドレス"
            readonly
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-text-field
            v-model="password"
            name="password"
            :type="showPassword ? 'text' : 'password'"
            label="パスワード"
            autocomplete="new-password"
            required
            :error-messages="errors.password"
          >
            <template v-slot:append>
              <v-icon
                class="fa-sm"
                style="cursor: pointer;"
                @click="togglePassword"
              >
                {{ showPassword ? "fa-eye" : "fa-eye-slash" }}
              </v-icon>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-text-field
            v-model="passwordConfirm"
            name="password_confirmation"
            :type="showPasswordConfirm ? 'text' : 'password'"
            label="パスワード(確認)"
            required
            :error-messages="errors.password_confirmation"
          >
            <template v-slot:append>
              <v-icon
                class="fa-sm"
                style="cursor: pointer;"
                @click="togglePasswordConfirm"
              >
                {{ showPasswordConfirm ? "fa-eye" : "fa-eye-slash" }}
              </v-icon>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>

    <!-- 居住地:海外 -->
    <template v-if="selectedLocale === 'en'">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-text-field
            v-model="inputFirstName"
            name="first_name"
            type="text"
            label="First Name"
            required
            :error-messages="errors.first_name"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            v-model="inputLastName"
            name="last_name"
            type="text"
            label="Last Name"
            required
            :error-messages="errors.last_name"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <input type="hidden" name="last_name_kana" value="" />
      <input type="hidden" name="first_name_kana" value="" />

      <v-layout v-if="!inviteTemplateFlg">
        <v-flex xs12>
          <v-text-field
            v-model="inputEmail"
            name="email"
            type="email"
            label="Email"
            required
            :error-messages="errors.email"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout v-if="inviteTemplateFlg">
        <v-flex xs12>
          <v-text-field
            v-model="inputInviteEmail"
            name="email"
            type="email"
            label="Email to register"
            readonly
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-text-field
            v-model="password"
            name="password"
            :type="showPassword ? 'text' : 'password'"
            label="Password"
            autocomplete="new-password"
            required
            :error-messages="errors.password"
          >
            <template v-slot:append>
              <v-icon
                class="fa-sm"
                style="cursor: pointer;"
                @click="togglePassword"
              >
                {{ showPassword ? "fa-eye" : "fa-eye-slash" }}
              </v-icon>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-text-field
            v-model="passwordConfirm"
            name="password_confirmation"
            :type="showPasswordConfirm ? 'text' : 'password'"
            label="Confirm Password"
            required
            :error-messages="errors.password_confirmation"
          >
            <template v-slot:append>
              <v-icon
                class="fa-sm"
                style="cursor: pointer;"
                @click="togglePasswordConfirm"
              >
                {{ showPasswordConfirm ? "fa-eye" : "fa-eye-slash" }}
              </v-icon>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>

    <!-- 居住地:選択無し -->
    <template v-if="!selectedLocale">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-text-field name="last_name" type="text" label="姓" disabled>
          </v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field name="first_name" type="text" label="名" disabled>
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-text-field name="last_name_kana" type="text" label="セイ" disabled>
          </v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            name="first_name_kana"
            type="text"
            label="メイ"
            disabled
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout v-if="!inviteTemplateFlg">
        <v-flex xs12>
          <v-text-field
            name="email"
            type="email"
            label="メールアドレス"
            disabled
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-text-field
            v-model="password"
            name="password"
            :type="showPassword ? 'text' : 'password'"
            label="パスワード"
            autocomplete="new-password"
            disabled
          >
            <template v-slot:append>
              <v-icon
                class="fa-sm"
                style="cursor: pointer;"
                @click="togglePassword"
              >
                {{ showPassword ? "fa-eye" : "fa-eye-slash" }}
              </v-icon>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-text-field
            v-model="passwordConfirm"
            name="password_confirmation"
            :type="showPasswordConfirm ? 'text' : 'password'"
            label="パスワード(確認)"
            disabled
          >
            <template v-slot:append>
              <v-icon
                class="fa-sm"
                style="cursor: pointer;"
                @click="togglePasswordConfirm"
              >
                {{ showPasswordConfirm ? "fa-eye" : "fa-eye-slash" }}
              </v-icon>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>

    <template v-if="selectedLocale">
      <v-layout>
        <v-flex xs12 wrap class="register-newsletter-info">
          ご入力いただいた情報は
          <a href="https://www.ncblibrary.com/footer/privacy" target="_blank">
            プライバシーポリシー
          </a>
          の記載に基づいて適切に管理します。
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 wrap class="register-newsletter-info">
          また、入力いただいたメールアドレス宛に当社より定期的にメールをお送りいたします。
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="register-submit">
          <v-btn type="submit">
            同意して登録
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
export default {
  props: {
    old: {
      type: Object,
      default: () => ({}),
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    inviteTemplateFlg: {
      type: Boolean,
      default: false,
    },
    inviteEmail: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      /** v-model参照用変数定義 */
      selectedLocale: this.old.locale,
      inputLastName: this.old.last_name,
      inputFirstName: this.old.first_name,
      inputLastNameKana: this.old.last_name_kana,
      inputFirstNameKana: this.old.first_name_kana,
      inputEmail: this.old.email,
      password: null,
      passwordConfirm: null,
      inputInviteEmail: this.inviteEmail,

      /** パスワードマスク状態フラグ */
      showPassword: false,
      showPasswordConfirm: false,
    };
  },
  methods: {
    /** マスク状態変更 */
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    togglePasswordConfirm() {
      this.showPasswordConfirm = !this.showPasswordConfirm;
    },
  },
};
</script>

<style lang="scss">
.register {
  &-container {
    padding: 0px !important;
  }

  &-attention {
    color: red;
    font-size: 1rem;
  }

  &-locale {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-submit {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-newsletter-info {
    font-size: 1rem;
  }
}
</style>
